import { ReactNode } from 'react';
import { EntityValidityRenderer as EntityValidityRendererType } from '@/schemas/sceneDataSchema';
import { useEntityTargetsValidity } from '@/hooks/use-entity-validity';

interface EntityValidityRendererProps {
  component: EntityValidityRendererType;
  validChild: ReactNode;
  invalidChild: ReactNode;
}

export function EntityValidityRenderer({ component, validChild, invalidChild }: EntityValidityRendererProps) {
  const isValid = useEntityTargetsValidity(component.entity_targets);

  return <>{isValid ? validChild : invalidChild}</>;
}
